import { createQueryKey } from '../../../../query/createQueryKeyFactory';
import { QueryKey, QueryKeyParam } from '../../../../query/types';

const studentFeesConsumerStudentsFeesKeys = <T extends QueryKey>(keys: T) => {
  const key = [...keys, 'fees'] as const;
  return createQueryKey({
    all: [...key] as const,
    infinite: [...key, 'infinite'] as const,
    id: <U extends QueryKeyParam>(uuid: U) =>
      createQueryKey({
        all: [...key, uuid] as const,
        detail: [...key, uuid, 'detail'] as const,
      }),
  });
};

export { studentFeesConsumerStudentsFeesKeys };
